export enum SettingIds {
  eReception = 'eReception',
  communityManager = 'communityManager',
  occasions = 'occasions',
  roomBooking = 'roomBooking',
  deskBooking = 'deskBooking',
  deskReservation = 'oasisReservation',
  openWorkspaces = 'openWorkspaces',
}
